import {
  GET_CATEGORIES_MULTI,
  GET_CATEGORIES_MULTI_SUCCESS,
  GET_CATEGORIES_MULTI_ERROR,
} from "./actions";

const initialState = {
  // Store only rows like legacy categoryList flow
  categoriesMultiRows: [],
  loading: false,
  error: null
};

export default function categoryReducer(state = initialState, action) {
  switch (action.type) {
    case GET_CATEGORIES_MULTI:
      return { 
        ...state, 
        loading: true,
        error: null
      };
      
    case GET_CATEGORIES_MULTI_SUCCESS:
      return { 
        ...state, 
        loading: false,
        categoriesMultiRows: action.payload || [],
        error: null
      };
      
    case GET_CATEGORIES_MULTI_ERROR:
      return { 
        ...state, 
        loading: false,
        error: action.payload
      };
      
    default:
      return state;
  }
}
